import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Job } from "../../../Types/Job";

interface ApplicationReviewState {
    job: Job | undefined;
}

const initialState: ApplicationReviewState = {
    job: undefined,
}

export const applicationReviewSlice = createSlice({
    name: 'ApplicationReview',
    initialState,
    reducers: {
        setApplicationReviewJob(state, action: PayloadAction<ApplicationReviewState["job"]>){
            state.job = action.payload;
        }
    }
})

export const {
    setApplicationReviewJob
} = applicationReviewSlice.actions

export default applicationReviewSlice.reducer

